import { FunctionComponent, useContext, useEffect, useState } from "react";
import styles from "./DashboardHeader.module.css";
import images from "../../../assets/images/index";
import ProfileDropdown from "../dropdown/profile-dropdown/ProfileDropdown";
import { CircularProgress, Dialog, Menu } from "@mui/material";
import { GrClose } from "react-icons/gr";
import SearchDropdown from "../dropdown/search-dropdown/SearchDropdown";
import NotificationComponent from "../notification/NotificationComponent";
import { globalContext } from "../../../Provider/AppProvider";
import { useLazyQuery } from "@apollo/client";
import { GLOABAL_SEARCH,GLOABAL_SEARCH_BY_LOGITIX_USER,GLOABAL_SEARCH_BY_Marketing_USER } from "./api/SearchUserandTickets";
import PopupComponent from "../success-popup/PopupComponent";
import { CustomPaperComponent, roles } from "../../../helper";
import { useLocation, useNavigate } from "react-router-dom";
import ChangePassword from "../change-password/ChangePassword";

interface headerProps{
  loadingUserProfile: boolean;
}
const DashboardHeader: FunctionComponent<headerProps> = ({loadingUserProfile}) => {
  const { searchIcon, notificationIcon,DefaultProfile } = images;
  const [anchorEl, setAnchorEl] = useState(null);
  const {globalState, handleGlobalState} = useContext <any>(globalContext)
  const [anchorElNotification, setAnchorElNotification] = useState(null);
  const [searchText, setSearchText] = useState<string>("");
  const [showSearch, setShowSearch] = useState<boolean>(false);
  const [searchResult, setSearchResult] = useState<any>("");
  const [finalsearch, setFinalsearch] = useState<string>('');
  const [userProfile, setUserProfile] = useState<string>('');
  const baseURL = process.env.REACT_APP_FRONTEND_URL;
  const [email,setEmail] = useState<boolean>(false);
  const StyledComponent = CustomPaperComponent();
  const [openSuccessDialog, setOpenSuccessDialog] = useState<boolean>(false);
  const [openDialog, setOpenDialog] = useState(false);
  const {pathname} = useLocation();

  const navigate = useNavigate();
  
  const open = Boolean(anchorEl);
  const openNotificaiton = Boolean(anchorElNotification)
  const [globalSearch] = useLazyQuery(GLOABAL_SEARCH,{
    fetchPolicy:'no-cache',
    onCompleted : (data) =>{
      setSearchResult (data)
    }
  })
  const [globalSearchByLogitixUser] = useLazyQuery(GLOABAL_SEARCH_BY_LOGITIX_USER,{
    fetchPolicy:'no-cache',
    onCompleted : (data) =>{
      setSearchResult (data)
    }
  })
  const [globalSearchByMarketingUser] = useLazyQuery(GLOABAL_SEARCH_BY_Marketing_USER,{
    fetchPolicy:'no-cache',
    onCompleted : (data) =>{
      setSearchResult (data)
    }
  })
  //Opening the profile dropdown
  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  //closing the profile dropdown
  const handleClose = () => {
    setAnchorEl(null);
    setAnchorElNotification(null)
  };

  const handleNotificationClick = (event: any) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleCloseDialogPop = () => {
    setOpenSuccessDialog(false);
    navigate("/login");
  };

    //change password dialog is closed
    const handleCloseDialog = () => {
      setOpenDialog(false);
      // handleClose();
    };

  //it shows the dropdown pop
  const handleSearch = async (searchString: string) => {
    if(searchString.includes('@')){
      setEmail(true);
    }
    if (searchString.trim().length > 2 && !globalState.notification.notificationClicked && !globalState.error.errorClicked) {
      setShowSearch(true);
      if(globalState.profile.userRole === roles.ADMIN || globalState.profile.userRole === roles.AFFILIATER_ADMIN){
        globalSearch({
        variables: {
          searchText: `${searchString.trim()}%`,
          searchEvent: `%${searchString.trim()}%`
        },
      });
    } else if(globalState.profile.userRole === "marketing_user") {
      globalSearchByMarketingUser({
        variables: {
          searchText: `${searchString.trim()}%`,
          searchEvent: `%${searchString.trim()}%`
        },
      });
    }
    else{
      globalSearchByLogitixUser({
        variables: {
          searchText: `${searchString.trim()}%`,
          searchEvent: `%${searchString.trim()}%`
        },
      });
    }
    } else {
      const tempstate = {...globalState}
      tempstate.globalSearch.searchtext = "";
      handleGlobalState(tempstate)
      setSearchResult([]);
      setShowSearch(false);
    }
  };
useEffect(()=>{
  setUserProfile(globalState?.profile?.photo);
},[globalState?.profile?.profileUpdate,globalState?.profile?.photo])
  //called when the input is clicked
  const handleSearchClick = (data: any) => {
    if (searchText.includes("@")) {
      if(data?.u_email_id){
        setSearchText(data?.u_email_id);
        setFinalsearch(data?.u_email_id)
      }else{
        setSearchText(data?.a_email_id);
        setFinalsearch(data?.a_email_id)
      }
    } else {
      if(data?.u_full_name){
        setSearchText(data?.u_full_name);
        setFinalsearch(data?.u_full_name);
      }else if(data?.e_name){
        setSearchText(data?.e_name);
        setFinalsearch(data?.e_name);
      }else if(data?.lc_name){
        setSearchText(data?.lc_name);
        setFinalsearch(data?.lc_name);
      }else if(data?.user?.u_full_name){
        setSearchText(data?.user?.u_full_name);
        setFinalsearch(data?.user?.u_full_name);
      }
    }
    setShowSearch(false);
    setEmail(false);
  };


  useEffect(()=>{
    const tempState = {...globalState};
    handleGlobalState(tempState)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.notification.reSettingNotificationCount])


 useEffect(()=>{
  const tempstate = {...globalState}
  tempstate.globalSearch.searchtext = finalsearch
  handleGlobalState(tempstate)
 // eslint-disable-next-line react-hooks/exhaustive-deps
 }, [finalsearch,setFinalsearch,globalState.notification.text,globalState.error.text])

 const handleCancel = () => {
    const tempState = {...globalState}
    setSearchText("");
    setShowSearch(false);
    setFinalsearch("")
    setEmail(false);
    tempState.affiliateNumberOfUsers.numberOfUsers = null;
    tempState.globalSearch.searchtext = "";
    tempState.notification.text = "";
    tempState.notification.notificationClicked = false;
    tempState.notification.tp_id_array=null;
    tempState.notification.ticketId = null;
    tempState.notification.tpId = null;
    tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel
    tempState.error.text = "";
    tempState.error.errorClicked=false
    tempState.error.approximateTpArray = null
    tempState.error.ticketPlacementId = null
    tempState.error.userError = false
    tempState.soldTickets.emailId = ""
    tempState.soldTickets.failed = false
    handleGlobalState(tempState)
  };
  useEffect(() =>{
    setSearchText(globalState.globalSearch.searchtext);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.globalSearch.searchtext])

  useEffect(()=>{
    if(globalState.notification.text){
      setSearchText(globalState.notification.text);
      const tempState = {...globalState}
      tempState.globalSearch.searchtext =globalState.notification.text ;
      handleGlobalState(tempState)
    }else if (globalState.error.text){
      setSearchText(globalState.error.text);
      const tempState = {...globalState}
      tempState.globalSearch.searchtext = globalState.error.text;
      handleGlobalState(tempState)
    }else{
      setSearchText("");
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[globalState.notification.text,globalState.error.text])


  useEffect(()=>{
    if(searchText !== globalState.notification.text && globalState.notification.notificationClicked){
    const tempState = {...globalState};
    tempState.notification.text = "";
    tempState.notification.notificationClicked = false;
    tempState.notification.tp_id_array=null;
    tempState.notification.ticketId = null;
    tempState.notification.tpId = null;
    tempState.notification.notificationSearchCancel = !globalState.notification.notificationSearchCancel
    handleGlobalState(tempState)
    }else if(searchText !== globalState.error.text && globalState.error.errorClicked ){
      const tempState = {...globalState};
      tempState.error.text = "";
      tempState.error.errorClicked=false
      tempState.error.approximateTpArray = null
      tempState.error.ticketPlacementId = null
      tempState.error.status = ""
      handleGlobalState(tempState)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[searchText])
  return (
    <div className={styles.dashboardHeader} style={{display: `${(pathname === "/new-list" || (globalState.profile.userRole === roles.SUPER_USER && pathname === "/dashboard")) ? "none" : ""}`}}>
      <div className={searchText !== '' ? styles.inSearchText : styles.search}>
        <div className={styles.searchContainer}>
          <div className={styles.container}>
            <img
              className={styles.sharpOutlineSearch}
              alt="SearchIcon"
              src={searchIcon}
            />
            <input
              type="search"
              className={styles.search1}
              placeholder="Search..."
              aria-label="Search"
              value={searchText}
              onChange={(e) => {
                setSearchText( globalState.notification.notificationClicked?e.target.value.trim():e.target.value);
                handleSearch(e.target.value);
              }}
            />
            {searchText && (
              <GrClose className={styles.closeIcon} onClick={handleCancel} data-testid="closeicon"/>
            )}
            {showSearch && (
              <SearchDropdown
                searchResult={searchResult}
                handleSearchClick={handleSearchClick}
                searchInput={searchText}
                finalsearch = {finalsearch}
                setFinalsearch = {setFinalsearch}
                setEmail = {setEmail}
                email = {email}
              />
            )}
          </div>
        </div>
      </div>
      <div className={styles.profileAndNotification}>
        { (globalState.profile.userRole === "marketing_user" || globalState.profile.userRole === roles.SUPER_USER) ?
        null
        :
        <div onClick={handleNotificationClick}>
        <img
          className={styles.sharpOutlineNotification}
          alt="notificationIcon"
          src={notificationIcon}
          data-testid = "notificationicon"
        />
        {(globalState.notificationCount.past > 0 || globalState.notificationCount.recent > 0) && <div className={styles.shape} />}
        </div>}
        {
          loadingUserProfile 
        ?  <div className={styles.profileCircularProgress}>
            <CircularProgress color="primary" size={30} />
          </div>
        :
        <div className={styles.profile} data-testid='profileClick'onClick={handleClick}>
          <div className={styles.profileOuterCircle}>
          <img className={styles.imgIcon} alt="userProfile" src={userProfile?(baseURL+userProfile):DefaultProfile } />
          </div>
          <div className={styles.userName}>
            {globalState?.profile?.firstName
              ? globalState?.profile?.firstName
              : ""}
            &nbsp;
            {globalState?.profile?.lastName
              ? globalState?.profile?.lastName
              : ""}
          </div>
        </div>
        }   
      </div>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        MenuListProps={{
          disablePadding: true,
        }}
      >
        <ProfileDropdown handleClose={handleClose} setOpenSuccessDialog={setOpenSuccessDialog} setOpenDialog={setOpenDialog}/>
      </Menu>

      <Menu
        anchorEl={anchorElNotification}
        id="account-menu"
        open={openNotificaiton}
        onClose={handleClose}
        transformOrigin={{ horizontal: "left", vertical: "top" }}
        anchorOrigin={{ horizontal: "left", vertical: "bottom" }}
        MenuListProps={{
          disablePadding: true,
        }}
        classes={{
          paper: styles.customMenu
        }}
      >
        <NotificationComponent closePopup={handleClose}/>
      </Menu>
      <Dialog
          open={openSuccessDialog}
          onClose={handleCloseDialogPop}
          PaperComponent={StyledComponent}
        >
          <PopupComponent
            handleClose={handleCloseDialogPop}
            title={"Password Updated"}
            subTitle={
              "Your password has been successfully updated. Please sign in to your account."
            }
          />
        </Dialog>
        <Dialog open={openDialog} classes={{paper:styles.customDialog}}>
        <ChangePassword handleCloseDialog={handleCloseDialog} setOpenSuccessDialog={setOpenSuccessDialog}/>
      </Dialog>
    </div>
  );
};

export default DashboardHeader;
